import { render, staticRenderFns } from "./fiscal.vue?vue&type=template&id=8c44f5f8&scoped=true&"
import script from "./fiscal.vue?vue&type=script&lang=js&"
export * from "./fiscal.vue?vue&type=script&lang=js&"
import style0 from "./fiscal.vue?vue&type=style&index=0&id=8c44f5f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c44f5f8",
  null
  
)

export default component.exports